module.exports = __webpack_public_path__ + "static/media/bootloader-dark.8b32cdcd.png";